import React from "react";
import { ClientContext } from "@thd-nucleus/app-render/dist/client";
import B2BTheme from "@thd-olt-global/b2b-theme";
import { NewRelicBridge } from "@thd-olt-component-react/new-relic-bridge";
import { whyDidYouRender } from "../wdyr";
import { App } from "./App";
import { getRoutes } from "./routes";

NewRelicBridge.init();
whyDidYouRender.init();

document.addEventListener("DOMContentLoaded", async () => {
  const client = new ClientContext();
  client.setExperienceRoutes(getRoutes());
  if (client.customer.type === "b2b") {
    client.setTheme({ name: "b2b", template: B2BTheme });
  }

  client.render(
    <App recaptchaV3Key={client.expConfiguration.recaptchaV3Key} />
  );
});
